import { useEffect } from 'react';
import { SEO, VIDEO, BRAND } from '../data/dgpt';
function upsertMeta(attribute: 'name' | 'property', key: string, content: string) {
  let element = document.head.querySelector<HTMLMetaElement>(`meta[${attribute}="${key}"]`);
  if (!element) {
    element = document.createElement('meta');
    element.setAttribute(attribute, key);
    document.head.appendChild(element);
  }
  element.setAttribute('content', content);
}

/** Homepage metadata, Open Graph, canonical, and Organization / SoftwareApplication schema. */
export function SeoHead() {
  useEffect(() => {
    document.title = SEO.title;
    upsertMeta('name', 'description', SEO.description);
    upsertMeta('property', 'og:title', SEO.title);
    upsertMeta('property', 'og:description', SEO.description);
    upsertMeta('property', 'og:type', 'website');
    upsertMeta('property', 'og:url', SEO.url);
    if (VIDEO.posterLocal) upsertMeta('property', 'og:image', VIDEO.posterLocal);
    upsertMeta('name', 'twitter:card', 'summary_large_image');
    upsertMeta('name', 'twitter:title', SEO.title);
    upsertMeta('name', 'twitter:description', SEO.description);
    let canonical = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = SEO.url;

    // Warm up the poster image origin only — the Vimeo player is not contacted until play.
    if (!document.head.querySelector('link[data-dgpt-preconnect]')) {
      const preconnect = document.createElement('link');
      preconnect.rel = 'preconnect';
      preconnect.href = 'https://i.vimeocdn.com';
      preconnect.setAttribute('data-dgpt-preconnect', 'true');
      document.head.appendChild(preconnect);
    }
    const structuredData = {
      '@context': 'https://schema.org',
      '@graph': [{
        '@type': 'Organization',
        name: 'StartupFuel',
        url: 'https://www.startupfuel.com'
      }, {
        '@type': 'SoftwareApplication',
        name: 'DiligenceGPT',
        applicationCategory: 'BusinessApplication',
        operatingSystem: 'Web',
        url: SEO.url,
        description: `${BRAND.tagline} ${BRAND.category}`,
        publisher: {
          '@type': 'Organization',
          name: 'StartupFuel'
        }
      }]
    };
    let script = document.head.querySelector<HTMLScriptElement>('script[data-dgpt-structured-data]');
    if (!script) {
      script = document.createElement('script');
      script.type = 'application/ld+json';
      script.setAttribute('data-dgpt-structured-data', 'true');
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(structuredData);
  }, []);
  return null;
}